import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useAuth } from "@/auth/use-auth";
import { env } from "@/lib/env";

import { gatewayRoot } from "../../theme-editor/api/editorApi";
import { type ContentApi, createContentApi } from "./contentApi";
import { ContentApiContext } from "./context";

export function useContentApi(): ContentApi {
  const injected = useContext(ContentApiContext);
  const { session } = useAuth();
  const { i18n } = useTranslation();
  const token = session?.accessToken ?? null;
  const language = i18n.language;
  return useMemo(
    () =>
      injected ??
      createContentApi({
        baseUrl: gatewayRoot(env.VITE_API_BASE_URL),
        getAccessToken: () => token,
        getLocale: () => language,
      }),
    [injected, token, language],
  );
}
